import { getArea, getLength } from 'ol/sphere.js';
import { Style, Text, Stroke, Fill } from 'ol/style';
import { LineString, Point } from 'ol/geom';

export default class MeasurementsStyleHelper {
  constructor(geometryType, unit) {
    this.geometryType = geometryType;
    this.unit = unit;
    this.lineStyle = new Style({ stroke: new Stroke({ color: '#ffcc33', width: 2 }) });
    this.polygonStyle = new Style({
      stroke: new Stroke({
        color: '#ffcc33',
        width: 2
      }),
      stroke: new Stroke({
        color: '#ffcc33',
        width: 2
      }),
      fill: new Fill({
        color: [0, 0, 255, 0.1]
      })
    });
  }

  getStyleFunction(defaultStyle) {
    const self = this;
    return function(feature) {
      const styles = [self.basicStyle()];
      const geometry = feature.getGeometry();
      
      if (self.geometryType === 'LineString') {
        geometry.forEachSegment(function(start, end) { styles.push(self.segmentTextStyle(start, end)); });
      }

      styles.push(self.lastPointStyle(geometry));
  
      return styles;
    }
  }

  getDrawnStyleFunction() {
    const self = this;

    return function(feature) {
      const styles = [self.basicStyle()];
      const geometry = feature.getGeometry();
      
      if (self.geometryType === 'LineString') {
        geometry.forEachSegment(function(start, end) { styles.push(self.segmentTextStyle(start, end)); });
      }

      styles.push(self.lastPointStyle(geometry, true));
  
      return styles;
    }
  }

  basicStyle() { return this.geometryType === 'Polygon' ? this.polygonStyle : this.lineStyle; }

  segmentTextStyle(start, end) {
    const styleGeometry = new LineString([start, end]);

    return new Style({
      geometry: styleGeometry,
      text: new Text({
        text: this.formatLength(styleGeometry),
        scale: 1.2,
        placement: 'line',
        fill: new Fill({ color: 'white' }),
        stroke: new Stroke({ color: [0, 0, 0, 1], width: 2 }),
        textBaseline: 'bottom'
      })
    });
  }

  formatLength(geometry) {
    const length = getLength(geometry, { projection: "EPSG:2180" });
    return this.unit === 'km' ? `${Math.round(length / 1000 * 100) / 100} km` : `${Math.round(length * 100) / 100} m`;
  }

  lastPointStyle(geometry, featureDrawn) {
    const styleGeometry = this.geometryType === 'Polygon' ? geometry : new Point(geometry.getCoordinates().pop());
    return new Style({
      geometry: styleGeometry,
      text: new Text({
        text: this.lastPointLabel(geometry),
        scale: 1.5,
        placement: 'point',
        backgroundFill: new Fill({ color: [0, 0, 0, 0.5] }),
        offsetY: featureDrawn ? 0 : 16,
        fill: new Fill({ color: 'white' }),
        padding: [8, 8, 8, 8],
        overflow: true
      })
    });
  }

  lastPointLabel(geometry) {
    let output = null;

    if (this.geometryType === 'Polygon') {
      const area = getArea(geometry, { projection: "EPSG:2180" });
      const length = getLength(geometry, { projection: "EPSG:2180" });

      if (this.unit === 'km') {
        output = `Powierzchnia: ${Math.round(area / 1000000 * 100) / 100} km2 Obwód: ${Math.round(length / 1000 * 100) / 100} km`;
      } else {
        output = `Powierzchnia: ${Math.round(area * 100) / 100} m2 Obwód: ${Math.round(length * 100) / 100} m`;
      }
    } else {
      const length = getLength(geometry, { projection: "EPSG:2180" });
      output = this.unit === 'km' ? `Łącznie: ${Math.round(length / 1000 * 100) / 100} km` : `Łącznie: ${Math.round(length * 100) / 100} m`;
    }
    
    return output;
  }
}